export const partners = [
    "asurion",
    "verizon",
    "att",
    "mcafee",
    "tmobile",
    "cricket",
    "adt",
    "youtubetv",
    "amazonrouter",
];
export const lobs = ["soluto", "mobility", "care"];
